<div>
  <div class="container flex borderBottom">
    <div id="title">
      <h3 id="title">
        Get Quote |
        <app-company-quoteid-header [quote]="quoteRequestState"></app-company-quoteid-header>
      </h3>
    </div>
    <app-quote-review-actions *ngIf="quoteRequestState?.quoteRequestType != 'QuickQuote'" (offersActioned)="onOffersActioned($event)" id="rejectAllButtonDiv"></app-quote-review-actions>
  </div>

  <app-quote-note></app-quote-note>

  <app-quote-settings
    #settings
    [contractLengths]="this.contractLengths"
    (fetchQuote)="getQuote($event)"
    (marginChanged)="marginChanged($event)"
    [quoteRequestState]="quoteRequestState"
    [showUpliftInvalid]="requestAQuoteButtonPressedAndPageInvalid"
    (isGetQuotePageValid)="setGetQuotePageValid($event)"
    [pricingAPICall]="generatingQuote || waitForLoadProfileCall"
  >
    <ng-content quoteSettings select="[quoteSettings]"></ng-content>
  </app-quote-settings>

  <app-quote-status-message></app-quote-status-message>
  <div class="btnCenter" *ngIf="this.showRequestAQuoteButton()">
    <button id="requestAQuoteBtn" mat-flat-button color="accent" type="button" (click)="sendQuoteRequestToSupplier($event)" [disabled]="isReadOnly">
      <img src="/assets/icons/icon-money.svg" class="prefix" />
      Request a Quote
    </button>
  </div>
  <!-- TODO: Verify that isQuotingDisabled() is the correct function to use here -->
  <app-quote-results
    *ngIf="quoteRequestState?.status !== 'Expired' && !isQuotingDisabled()"
    (offersActioned)="onOffersActioned($event)"
    [allMarginChanged]="this.isAllMarginChanged"
  ></app-quote-results>
</div>
